import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtNum, MONTHS_IT } from "@/lib/constants";

const rows = [
  ["Residuo anno precedente", "previous_residual"],
  ["Maturato fino al mese", "accrued_to_month"],
  ["Goduto nel mese", "consumed_month"],
  ["Goduto da gennaio", "consumed_ytd"],
  ["Residuo aggiornato", "residual"],
];

export function RateiDetailGrid({ pool, testid = "ratei-detail" }) {
  const unit = pool?.unit === "days" ? "gg" : "h";
  if (!pool) {
    return <div className="py-5 text-sm text-suite-neutral-500">Nessun dato disponibile.</div>;
  }
  return (
    <div className="overflow-hidden rounded-lg border border-suite-neutral-200" data-testid={testid}>
      {rows.map(([label, key], index) => (
        <div
          key={key}
          className={`flex items-center justify-between gap-4 px-4 py-3 ${index ? "border-t border-suite-neutral-100" : ""} ${key === "residual" ? "bg-suite-primary/5" : "bg-white"}`}
        >
          <span className={`text-sm ${key === "residual" ? "font-semibold text-suite-neutral-800" : "text-suite-neutral-600"}`}>{label}</span>
          <span className={`font-mono tabular-nums ${key === "residual" ? "text-lg font-bold text-suite-primary" : "text-sm font-semibold text-suite-neutral-800"}`}>
            {fmtNum(pool[key] || 0)} {unit}
          </span>
        </div>
      ))}
    </div>
  );
}

export function RateiDetailDialog({ open, onOpenChange, pool, label }) {
  const monthLabel = pool?.month ? MONTHS_IT[pool.month - 1] : "";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="ratei-detail-dialog">
        <DialogHeader>
          <DialogTitle>{label}</DialogTitle>
          <DialogDescription>
            Situazione al {monthLabel} {pool?.year || ""}. Dati in sola lettura.
          </DialogDescription>
        </DialogHeader>
        <RateiDetailGrid pool={pool} />
      </DialogContent>
    </Dialog>
  );
}
